import "@cloudscape-design/global-styles/index.css";
import { AgChartsEnterpriseModule, LicenseManager as AgChartsLicenseManager } from "ag-charts-enterprise";
import { AllEnterpriseModule, LicenseManager, ModuleRegistry, provideGlobalGridOptions } from "ag-grid-enterprise";
import React from "react";
import { createRoot } from "react-dom/client";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import App from "./App";
import { SnackBarContextProvider } from "./hooks/notify/snack-bar/snackbar-context";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";

ModuleRegistry.registerModules([
  AllEnterpriseModule.with(AgChartsEnterpriseModule),
]);

const LICENSE_KEY =
  "Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-095746}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{SpectacorGaming}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{23_January_2027}____[v3]_[0102]_MTgwMDY2MjQwMDAwMA==12ff364dd89ddc87a801724d43706974";

LicenseManager.setLicenseKey(LICENSE_KEY);
AgChartsLicenseManager.setLicenseKey(LICENSE_KEY);

provideGlobalGridOptions({ theme: "legacy" });

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <SnackBarContextProvider>
    <App />
  </SnackBarContextProvider>,
);

const initializeGA = () => {
  // eslint-disable-next-line no-undef
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "G-THDND6LX49");
};

initializeGA();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
